// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-sugestions {
    padding-top: var(--space-half-quarter);
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    height: 100%;           
}

.pages-sugestions__card {
    box-shadow: 0px 3.35742px 3.35742px rgba(170, 193, 182, 0.32);
    border-radius: var(--space-half-quarter);
    min-height: 108px;
}

.pages-sugestions__content {
    grid-column-start: 1;
    grid-column-end: 9;
    display: flex;
}
.pages-sugestions__content__title {
    margin-bottom: var(--space-and-half);
}
.pages-sugestions__content__title__text.baloa-headline-2 {
    color: var(--primary-very-dark-color);
}
.pages-sugestions__content__field {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    cursor: pointer;
}
.pages-sugestions__content__line {
    border-top: 1px solid var(--primary-light-color);
    padding: 0;
    margin: 0 auto 0 auto;
  }
.pages-sugestions__content__field:hover {
    background-color: var(--disabled-sb-font-color);
}
.pages-sugestions__content__field:active {
    background-color: var(--disabled-sb-font-color);
}
.pages-sugestions__content__field__icon span{
    margin-right: var(--space);
    font-size: var(--space-and-half);
    color: var(--secondary-color);
    
}
.pages-sugestions__content__field__data {
    display: flex;
    max-height: var(--space-x2);
    flex-grow: 1;
    margin-right: var(--space-half);
}

.pages-sugestions__content__field__icon-chevron {
    font-size: var(--space-and-half);
}
.pages-sugestions__content__button {
    margin-top: var(--space-x2);
    cursor: pointer;
    width: 30%;
}

.pages-sugestions__content__button__text{
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: var(--font-bold) !important;
    font-size: 12px !important;
    line-height: var(--space-and-half) !important;
    letter-spacing: 0.04em !important;
    color: var(--primary-very-dark-color) !important;
}

.pages-sugestions__settings {
    grid-column-start: 7;
    grid-column-end: 11;
}

.pages-sugestions__header__content__icon  span{
    margin-right: var(--space-and-half);
    font-size: var(--space-and-half);
    color: var(--secondary-color);
    cursor: pointer;
}
.baloa-card-1.pages-sugestions__card {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.pages-sugestions__card .baloa-card-1__title.baloa-normal-medium{
    color: var(--basic-gray-color);
    display: flex;
    align-items: center;
}

.pages-sugestions__card .baloa-card-1__button {
    position: unset;
    right: unset;
    top: unset;
}

.pages-sugestions__card .baloa-card-1__button .pages-sugestions__new-button {
    width: max-content;
}

.pages-sugestions__sugestions {
    margin-top: var(--space-and-half);
}

.pages-sugestions__card p.baloa-card-1__title.baloa-headline-6 {
    font-family: var( --secondary-font ) !important;
    font-style: normal;
    font-weight: normal !important;
    font-size: var( --space ) !important;
    line-height: var( --space-and-half ) !important;
    display: flex;
    align-items: center;
    letter-spacing: 0.005em !important;
    color: var( --basic-gray-color ) !important;
}

.pages-sugestions__card .pages-sugestions__icon {
    font-size: 40px;
    color: var( --primary-dark-color );
    margin-right: var( --space );
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .baloa-card-1.pages-sugestions__card {
        flex-direction: column;
    }
    .pages-sugestions__card .baloa-card-1__button .pages-sugestions__new-button {
        margin-top: calc( var(--space) + var(--space-eighth) );
        font-size: var(--space);
        line-height: calc( var(--space) + var(--space-eighth) );
    }

    .pages-sugestions__card .baloa-card-1__title.baloa-normal-medium {
        align-items: center;
        justify-content: center;
    }

    .pages-sugestions__card .pages-sugestions__icon {
        margin-right: calc( var(--space-half) + 2px );
        font-size: var(--space-x2);
    }

    .pages-sugestions__content__title {
        display: none;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-groups-suggestions/PagesSuggestionsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,aAAa;IACb,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA;IACI,gDAAgD;IAChD,UAAU;IACV,qBAAqB;EACvB;AACF;IACI,+CAA+C;AACnD;AACA;IACI,+CAA+C;AACnD;AACA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,6BAA6B;;AAEjC;AACA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,2BAA2B;IAC3B,eAAe;IACf,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,wCAAwC;IACxC,0BAA0B;IAC1B,6CAA6C;IAC7C,iCAAiC;IACjC,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,8BAA8B;IAC9B,oCAAoC;IACpC,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,sBAAsB;IAC1B;IACA;QACI,sDAAsD;QACtD,uBAAuB;QACvB,uDAAuD;IAC3D;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,6CAA6C;QAC7C,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".pages-sugestions {\n    padding-top: var(--space-half-quarter);\n    display: grid;\n    grid-template-columns: repeat(8, 1fr);\n    height: 100%;           \n}\n\n.pages-sugestions__card {\n    box-shadow: 0px 3.35742px 3.35742px rgba(170, 193, 182, 0.32);\n    border-radius: var(--space-half-quarter);\n    min-height: 108px;\n}\n\n.pages-sugestions__content {\n    grid-column-start: 1;\n    grid-column-end: 9;\n    display: flex;\n}\n.pages-sugestions__content__title {\n    margin-bottom: var(--space-and-half);\n}\n.pages-sugestions__content__title__text.baloa-headline-2 {\n    color: var(--primary-very-dark-color);\n}\n.pages-sugestions__content__field {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    display: flex;\n    align-items: center;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.pages-sugestions__content__line {\n    border-top: 1px solid var(--primary-light-color);\n    padding: 0;\n    margin: 0 auto 0 auto;\n  }\n.pages-sugestions__content__field:hover {\n    background-color: var(--disabled-sb-font-color);\n}\n.pages-sugestions__content__field:active {\n    background-color: var(--disabled-sb-font-color);\n}\n.pages-sugestions__content__field__icon span{\n    margin-right: var(--space);\n    font-size: var(--space-and-half);\n    color: var(--secondary-color);\n    \n}\n.pages-sugestions__content__field__data {\n    display: flex;\n    max-height: var(--space-x2);\n    flex-grow: 1;\n    margin-right: var(--space-half);\n}\n\n.pages-sugestions__content__field__icon-chevron {\n    font-size: var(--space-and-half);\n}\n.pages-sugestions__content__button {\n    margin-top: var(--space-x2);\n    cursor: pointer;\n    width: 30%;\n}\n\n.pages-sugestions__content__button__text{\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-bold) !important;\n    font-size: 12px !important;\n    line-height: var(--space-and-half) !important;\n    letter-spacing: 0.04em !important;\n    color: var(--primary-very-dark-color) !important;\n}\n\n.pages-sugestions__settings {\n    grid-column-start: 7;\n    grid-column-end: 11;\n}\n\n.pages-sugestions__header__content__icon  span{\n    margin-right: var(--space-and-half);\n    font-size: var(--space-and-half);\n    color: var(--secondary-color);\n    cursor: pointer;\n}\n.baloa-card-1.pages-sugestions__card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.pages-sugestions__card .baloa-card-1__title.baloa-normal-medium{\n    color: var(--basic-gray-color);\n    display: flex;\n    align-items: center;\n}\n\n.pages-sugestions__card .baloa-card-1__button {\n    position: unset;\n    right: unset;\n    top: unset;\n}\n\n.pages-sugestions__card .baloa-card-1__button .pages-sugestions__new-button {\n    width: max-content;\n}\n\n.pages-sugestions__sugestions {\n    margin-top: var(--space-and-half);\n}\n\n.pages-sugestions__card p.baloa-card-1__title.baloa-headline-6 {\n    font-family: var( --secondary-font ) !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-size: var( --space ) !important;\n    line-height: var( --space-and-half ) !important;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.005em !important;\n    color: var( --basic-gray-color ) !important;\n}\n\n.pages-sugestions__card .pages-sugestions__icon {\n    font-size: 40px;\n    color: var( --primary-dark-color );\n    margin-right: var( --space );\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .baloa-card-1.pages-sugestions__card {\n        flex-direction: column;\n    }\n    .pages-sugestions__card .baloa-card-1__button .pages-sugestions__new-button {\n        margin-top: calc( var(--space) + var(--space-eighth) );\n        font-size: var(--space);\n        line-height: calc( var(--space) + var(--space-eighth) );\n    }\n\n    .pages-sugestions__card .baloa-card-1__title.baloa-normal-medium {\n        align-items: center;\n        justify-content: center;\n    }\n\n    .pages-sugestions__card .pages-sugestions__icon {\n        margin-right: calc( var(--space-half) + 2px );\n        font-size: var(--space-x2);\n    }\n\n    .pages-sugestions__content__title {\n        display: none;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
